import { useEffect } from "react";
import { useThree } from "@react-three/fiber";
import { useObjectStore } from "../zustand/objects";

/** With frameloop="demand", redraw when destination-link hover changes (DOM reticle + mesh outlines). */
export function PreviewR3fInvalidateOnShapeHover() {
  const invalidate = useThree((s) => s.invalidate);
  const shapeHovered = useObjectStore((s) => s.shapeHovered);
  useEffect(() => {
    invalidate();
  }, [shapeHovered, invalidate]);
  return null;
}
